import type { FC } from "react";
import * as React from "react";

import { Failed, ServerError } from "./Errors";
import { ConvertationStatus } from "./Types";

interface Props {
    status: ConvertationStatus;
    onStatusReset: () => void;
}

export const ConvertationInfo: FC<Props> = props => {
    switch (props.status) {
        case ConvertationStatus.Failed: {
            return <Failed onClose={props.onStatusReset} />;
        }
        case ConvertationStatus.ServerError: {
            return <ServerError onClose={props.onStatusReset} />;
        }
        default: {
            return null;
        }
    }
};
